import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=c5fc6cc0&scoped=true"
import script from "./SystemNotifications.vue?vue&type=script&lang=js"
export * from "./SystemNotifications.vue?vue&type=script&lang=js"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=c5fc6cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fc6cc0",
  null
  
)

export default component.exports